import { render } from "./FAQs.vue?vue&type=template&id=0ae35804&scoped=true"
import script from "./FAQs.vue?vue&type=script&lang=js"
export * from "./FAQs.vue?vue&type=script&lang=js"

import "./FAQs.vue?vue&type=style&index=0&id=0ae35804&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae35804"]])

export default __exports__